import { Buffer } from 'buffer';

const expires = new Date(Date.now() + 24 * 60 * 60 * 1000);
const expiresAfter24hours = `Expires=${expires.toUTCString()}`;

export const addTenantCookie = (
  facilityID: string,
  id: string,
  cName: string = 'isTenantSignedIn='
) => {
  document.cookie = `${cName}${Buffer.from(
    `${facilityID}&${origin}&${id}`
  ).toString('base64')}; ${expiresAfter24hours}; path=/`;
};

export const getTenantCookie = (cName: string) => {
  return document.cookie.indexOf(cName);
};

export const deleteTenantCookie = (cName: string) => {
  document.cookie = cName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const getCookie = (cName: string) => {
  const name = cName + '=';
  const cDecoded = decodeURIComponent(document.cookie);
  const cArr = cDecoded.split('; ');
  let res = '';
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return Buffer.from(res, 'base64').toString();
};

export const getCookies = (cName: string) => {
  const name = cName + '=';
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return res ? res : '';
};

// Set the cookie
export const setMoveInReserveCookie = (
  cName: string = 'isMoveInReserveFailed'
) => {
  document.cookie = `${cName}=true; ${expiresAfter24hours}; path=/;`;
};

export const setNewTenantCookie = (
  newId: string,
  cName: string = 'newLedgerId'
) => {
  document.cookie = `${cName}=${newId}; ${expiresAfter24hours}; path=/;`;
};

// Remove the cookie
export const removeMoveInReserveCookie = () => {
  document.cookie =
    'isMoveInReserveFailed=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie =
    'isMoveInReserveSuccess=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

// Check if the cookie exists
export const checkMoveInReserveFailedCookie = () => {
  const cookies = document.cookie.split('; ');
  return cookies.some(cookie => cookie.startsWith('isMoveInReserveFailed='));
};

export const checkMoveInReserveSuccessCookie = () => {
  const cookies = document.cookie.split('; ');
  return cookies.some(cookie => cookie.startsWith('isMoveInReserveSuccess='));
};
